import { render, staticRenderFns } from "./ui-house-suggest.vue?vue&type=template&id=4379bf72&"
import script from "./ui-house-suggest.vue?vue&type=script&lang=js&"
export * from "./ui-house-suggest.vue?vue&type=script&lang=js&"
import style0 from "./ui-house-suggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4379bf72')) {
      api.createRecord('4379bf72', component.options)
    } else {
      api.reload('4379bf72', component.options)
    }
    module.hot.accept("./ui-house-suggest.vue?vue&type=template&id=4379bf72&", function () {
      api.rerender('4379bf72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-house-suggest/ui-house-suggest.vue"
export default component.exports